import { motion } from "framer-motion";

import techBgVideo from "../assests/Aivideo.mp4"; // <-- Add your video file in assets



import { useEffect, useState } from "react";
import { Link } from "react-router-dom";


export default function IndustriesTechnologyAI() {
  const [startAnim, setStartAnim] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);
   useEffect(() => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }, []);

  useEffect(() => {
    // Trigger animations after page loads
    setTimeout(() => setStartAnim(true), 300);
  }, []);

  // Animation Variants
  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.25, delayChildren: 0.3 },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 60 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };

  return (
    <section className="relative text-white py-24 px-6 font-orbitron overflow-hidden">
      {/* Background Fallback */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black" />

      {/* Background Video with Fade-in */}
      <motion.video
        autoPlay
        loop
        muted
        playsInline
        onLoadedData={() => setVideoLoaded(true)}
        initial={{ opacity: 0 }}
        animate={{ opacity: videoLoaded ? 0.4 : 0 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src={techBgVideo} type="video/mp4" />
      </motion.video>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-black/60 to-black/80" />

      {/* Heading */}
      <div className="relative z-10 text-center max-w-4xl mx-auto mb-20">
        <motion.h2
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-5xl md:text-7xl font-extrabold mb-6 bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent drop-shadow-lg"
        >
          🌐 Industries We Serve
        </motion.h2>
        <motion.h3
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
          className="text-2xl md:text-4xl font-semibold text-cyan-300"
        >
          Technology & Artificial Intelligence
        </motion.h3>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
          className="mt-6 text-lg md:text-xl text-gray-200 leading-relaxed"
        >
          The future is powered by{" "}
          <span className="font-semibold text-cyan-300">Technology & AI</span>.  
          At <span className="font-bold text-purple-400">Prisu Experts</span>, we don’t just provide data —  
          we fuel innovation. From training{" "}
          <span className="italic">intelligent assistants</span> to building{" "}
          <span className="italic">vision-powered applications</span>, our solutions scale  
          with the speed of technology.
        </motion.p>
      </div>

      {/* Contribution Cards */}
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate={startAnim ? "show" : "hidden"}
        className="relative z-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 max-w-7xl mx-auto"
      >
        {[
          {
            title: "📊 Curated AI Datasets",
            desc: "High-quality text, audio, image, and video data tailored for advanced model training.",
          },
          {
            title: "🏷 Smart Annotation",
            desc: "AI-assisted labeling services with human-in-the-loop validation for superior accuracy.",
          },
          {
            title: "🌍 Multilingual AI",
            desc: "Support in 50+ languages to help companies expand AI solutions globally.",
          },
          {
            title: "✅ AI Testing & Validation",
            desc: "Bias detection, stress-testing & quality checks for robust AI performance.",
          },
          {
            title: "🤖 Generative AI Support",
            desc: "Fine-tuning data pipelines for LLMs, chatbots, and creative AI applications.",
          },
          {
            title: "🔐 Responsible AI",
            desc: "Ethical dataset preparation ensuring fairness, transparency, and inclusivity.",
          },
          {
            title: "🚀 Scalable Solutions",
            desc: "Flexible services that grow with your AI product — from prototype to global rollout.",
          },
          {
            title: "🔎 Research & Insights",
            desc: "Domain-specific data preparation for academic and enterprise AI research.",
          },
        ].map((item, idx) => (
          <motion.div
            key={idx}
            variants={cardVariants}
            whileHover={{ scale: 1.05 }}
            className="bg-black/40 backdrop-blur-md p-8 rounded-2xl border border-cyan-400/20 shadow-lg hover:shadow-2xl transition relative group"
          >
            <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-cyan-500/10 to-purple-500/10 opacity-0 group-hover:opacity-100 transition" />
            <h4 className="text-xl font-semibold mb-4 text-cyan-300 relative z-10">
              {item.title}
            </h4>
            <p className="text-gray-200 leading-relaxed relative z-10">
              {item.desc}
            </p>
          </motion.div>
        ))}
      </motion.div>

      {/* Closing Statement */}
      <div className="relative z-10 max-w-4xl mx-auto mt-20 text-center">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="text-lg md:text-2xl text-gray-100 leading-relaxed"
        >
          With our expertise in{" "}
          <span className="font-semibold text-cyan-300">data engineering</span>  
          and <span className="font-semibold text-purple-400">AI innovation</span>,  
          we partner with visionary companies to build systems that{" "}
          <span className="text-cyan-400 font-semibold">think, learn, and evolve</span>.
        </motion.p>
      </div>

      {/* CTA */}
      <div className="relative z-10 text-center mt-12">
        <motion.a
          
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
         
          className="inline-block px-8 py-4 text-lg font-semibold rounded-full bg-gradient-to-r from-cyan-500 to-purple-600 text-white shadow-lg hover:shadow-2xl transition"
        >
           <Link to="/contact2">
          
         
          🚀 Start Your AI Journey with Us
           </Link>
        </motion.a>
      </div>
    </section>
  );
}
